// Phase 2 Landing Page - Shared Theme Tokens
// Based on TransparencyBoard dark aesthetic

export const theme = {
    colors: {
        // Base
        background: '#09090b',        // Zinc-950
        surface: 'rgba(24, 24, 27, 0.6)',
        surfaceSolid: '#18181b',      // Zinc-900

        // Text
        text: '#e4e4e7',              // Zinc-200
        textMuted: '#a1a1aa',         // Zinc-400
        textDark: '#52525b',          // Zinc-600
        textWhite: '#ffffff',

        // Accents
        accent: '#f97316',            // Orange-500
        accentLight: '#fdba74',       // Orange-300
        success: '#10b981',           // Emerald-500
        successLight: '#34d399',      // Emerald-400
        info: '#3b82f6',              // Blue-500
        purple: '#8b5cf6',            // Violet-500
        pink: '#ec4899',              // Pink-500
        yellow: '#eab308',            // Yellow-500
        red: '#ef4444',               // Red-500

        // Borders
        border: 'rgba(255, 255, 255, 0.08)',
        borderHover: 'rgba(255, 255, 255, 0.15)',
        borderAccent: 'rgba(249, 115, 22, 0.5)',
    },

    fonts: {
        mono: "'JetBrains Mono', monospace",
        sans: "'Inter', sans-serif",
    },

    // Glow effects
    glow: {
        orange: 'radial-gradient(circle, rgba(249, 115, 22, 0.08) 0%, rgba(0,0,0,0) 70%)',
        green: 'radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, rgba(0,0,0,0) 70%)',
    },

    // Glass card styles
    glass: {
        background: 'rgba(24, 24, 27, 0.6)',
        blur: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '16px',
    },

    // Spacing (8px increments)
    spacing: {
        xs: '8px',
        sm: '16px',
        md: '24px',
        lg: '32px',
        xl: '48px',
        xxl: '72px',
    },

    // Breakpoints
    breakpoints: {
        mobile: '480px',
        tablet: '768px',
        desktop: '1024px',
        wide: '1400px',
    },
};

// CSS for global font imports
export const globalFontImport = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500;700&display=swap');
`;

// Reusable keyframe animations
export const animations = {
    fadeInUp: `
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `,

    ping: `
    @keyframes ping {
      75%, 100% {
        transform: translate(-50%, -50%) scale(3);
        opacity: 0;
      }
    }
  `,

    pulse: `
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.5;
      }
    }
  `,
};

export default theme;
